module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-46.57a2b593.png";